import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    periodos: [],
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_PERIODOS = 'OBTENER_PERIODOS'
const ACTUALIZAR_PERIODO = 'ACTUALIZAR_PERIODO'
//*******************************************************************************************************************


//MÉTODOS 

export const obtenerPeriodos = createAsyncThunk(
    OBTENER_PERIODOS,
    async () => {
        try {
            const fullUrl = host + `Periodos/obtenerPeriodos`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarPeriodo = createAsyncThunk(
    ACTUALIZAR_PERIODO,
    async (data) => {
        try {
            const fullUrl = host + `Periodos/actualizarPeriodo`
            const res = await axios.put(fullUrl, data)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosPeriodos = createSlice({

    name: 'metodosPeriodos',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerPeriodos.fulfilled]: (state, { payload }) => {
            state.periodos = payload.data.data
        },
        [actualizarPeriodo.fulfilled]: (state, { payload }) => {
            
        }
    },

})


export const { } = metodosPeriodos.actions
export const PeriodosReducer = metodosPeriodos.reducer